import React from "react";

import Button from "../../../../global/button";
import NotAvailable from "../../../../../assets/not_available.png";

import "./styles.css";
import { useNavigate, useSearchParams } from "react-router-dom";

const NoProperties = ({ setShouldRepan }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleRefresh = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.delete("property-types");
    newSearchParams.delete("star");

    navigate({
      search: newSearchParams.toString(),
    });
    setShouldRepan(true);
  };
  return (
    <div className="not-available-property">
      <img
        alt="not-available"
        src={NotAvailable}
        className="not-available-image"
      />
      <h2 className="not-available-properties-title">Sorry, no results</h2>
      <div className="not-available-properties-suggestions">
        <span className="not-available-properties-text">
          Try the following to get results :
        </span>
        <ul className="not-available-properties-list">
          <li>Zoom out the map</li>
          <li>Search for a different location</li>
          <li>Change your filters</li>
        </ul>
      </div>
      <Button
        onClick={handleRefresh}
        className="not-available-properties-button"
      >
        Refresh results
      </Button>
    </div>
  );
};

export default NoProperties;
